import { useAtomValue } from 'jotai';
import UserDescription from '~/components/user-description';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { NotFound } from '~/components/not-found';
import { JSX } from 'react';

export default function UserDescriptionSection(): JSX.Element {
  const user = useAtomValue($CurrentAvailableUserOrNull);

  if (!user) {
    return (
      <section id="user-not-found">
        <NotFound />
      </section>
    );
  }

  return (
    <section id="user-description">
      <UserDescription user={user} />
    </section>
  );
}
